<!--  -->
<template>
  <div>
    <div v-if="!type" class="link-mini">
      <div @click="openMini" class="btn">立即前往小程序</div>
    </div>
    <div v-else class="businessOrder">
      <div class="clear"></div>
      <div class="search">
        <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/search.png" alt="" />
        <input @input="change()" v-model="orderId" placeholder="请输入订单号" />
        <button @click="search()">搜索</button>
      </div>
      <div v-if="orderList.length" class="order-list">
        <OrderCard
          @lookLogistics="lookLogistics"
          v-for="(item, index) in orderList"
          :key="index"
          :cardInfo="item"
        />
      </div>
      <div><EmptyData v-if="!orderList.length" :emptyName="'businessOrder'" /></div>
      <LogisticsDetail :showDetail="showDetail" :logistics="expressDetail" @close="close" />
      <LinkMini/>
    </div>
  </div>
</template>

<script>
import { reqWdtExpress, reqLogisticsDetail, urlScheme } from '@/api/businessOrder';
import EmptyData from '@/components/emptyData/emptyData.vue';
import LogisticsDetail from './component/logisticsDetail.vue';
import OrderCard from './component/orderCard.vue';
import LinkMini from './component/linkMini'

export default {
  components: {
    OrderCard,
    EmptyData,
    LogisticsDetail,
    LinkMini
  },
  data() {
    return {
      orderId: '',
      orderList: [],
      expressDetail: {},
      showDetail: false,
      type: this.$route.query.type
    };
  },
  computed: {},
  watch: {},
  methods: {
    async openMini() {
      const params = {
        appid: "wxdb89cfa2bb60f779",
        envVersion: "release", // trial  release
        path: 'pages/mine/mine',
        query: 'channel=dsckd'
      };
      const {code, data} = await urlScheme(params);
      if (code === 0) {
        window.location.href = data
      }
    },
    change() {
      this.orderId = this.orderId.replace(/\s*/g, '');
    },
    async search() {
      if (!this.orderId) {
        this.$toast('请输入订单号');
        return;
      }
      this.getExpressList(this.orderId);
    },
    async getExpressList(orderId) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: false,
        duration: 0,
      });
      const { data } = await reqWdtExpress(orderId);
      this.orderList = data || [];
      this.$toast.clear();
    },
    lookLogistics(expressNo,addresseePhone) {
      this.getLogicsticsDetail(expressNo,addresseePhone);
    },
    async getLogicsticsDetail(expressNo,addresseePhone) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: false,
        duration: 0,
      });
      const { code, msg, data } = await reqLogisticsDetail({expressNo,addresseePhone});
      this.$toast.clear();
      if (code === 0) {
        this.showDetail = true;
        this.expressDetail = data;
      } else {
        this.$toast(msg);
      }
    },
    close() {
      this.showDetail = false;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.businessOrder {
  width: 100%;
  padding: 0;
  .clear{
    clear: both;
  }
  .search {
    position: relative;
    padding: 40px 40px;
    background: #fff;
    width: 100%;
    height: 160px;
    box-sizing: border-box;
    img {
      position: absolute;
      top: 69px;
      left: 64px;
      width: 24px;
      height: 24px;
      display: block;
    }
    input {
      width: 100%;
      height: 80px;
      padding-left: 64px;
      color: #333;
      font-size: 28px;
      background: #f7f8fc;
      border-radius: 44px;
      display: block;
    }
    button {
      position: absolute;
      top: 40px;
      right: 40px;
      width: 120px;
      color: #fff;
      font-weight: 400;
      font-size: 28px;
      line-height: 80px;
      background: #ff7f41;
      border-radius: 44px;
      padding: 0;
    }
  }
  .order-list {
    padding: 40px;
    padding-bottom: 380px;
  }
}
.link-mini{
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-image: url("https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/businessOrder/buesnessOrderLinkMini.png");
  background-repeat: no-repeat;
  background-size: 100%;
  background-color: rgb(231,136,62);
  .btn{
    width: 670px;
    height: 88px;
    background: #FFFFFF;
    border-radius: 50px;
    margin:auto;
    text-align: center;
    line-height: 88px;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin-bottom: 96px;
    font-weight: 500;
    font-size: 32px;
    color: #FF7F41;
  }
}
</style>
